<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import JournalEntries from "@/components/widgets/journal-entries.vue";
import JournalModal from "@/components/modals/journal-modal.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import FinanceAttachments from "@/components/modals/finance-attachments.vue";
import FinanceOverviewReports from "@/components/widgets/finance-overview-reports.vue";
import JournalReports from "@/components/widgets/journal-reports.vue";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
export default {
    name: "jev",
    components: {
        Layout,
        PageHeader,
        JournalEntries,
        JournalModal,
        PrintOptions,
        FinanceAttachments,
        FinanceOverviewReports,
        JournalReports,
        DatePicker,
    },
    data() {
        return {
            title: "Journals",
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Journals",
                    active: true,
                },
            ],
            filter: null,
            journalEntries: [],
            journals: [],
            fundSources: [],
            fundClusters: [],
            accounts: [],
            loading: false,
            tabModel: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            modalTitle: "",
            selectedJournal: {},
            selectedTab: 'pending',
            months: [
                { value: 1, text: "January" },
                { value: 2, text: "February" },
                { value: 3, text: "March" },
                { value: 4, text: "April" },
                { value: 5, text: "May" },
                { value: 6, text: "June" },
                { value: 7, text: "July" },
                { value: 8, text: "August" },
                { value: 9, text: "September" },
                { value: 10, text: "October" },
                { value: 11, text: "November" },
                { value: 12, text: "December" },
            ],
            selectedRange: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)],
        };
    },
    watch: {
        selectedRange() {
            if(this.selectedTab === 'posted'){
                this.getStatus('posted');
            }
        },
    },
    async created(){
        this.loading = true;
        await this.getJournalTypes();
        await this.changeData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
        this.loading = false;
        await this.fetchAccounts();
        this.getFundClusters();
    },
    methods: {
        getFundClusters() {
            this.$store
                .dispatch("fundcluster/GetFundCluster")
                .then((res) => {
                    const isAdmin = this.$store.state.decrypt.isAdmin();
                    if (isAdmin) {
                        this.fcOptions = res.data;
                    } else {
                        const fcAccess = this.$store.state.decrypt.userAccessList()
                        .find((item) => item.Type.toLowerCase() === "finance" && item.Access.toLowerCase().includes("fund cluster"));
                            if(fcAccess){
                                const filterAccess = this.$store.state.decrypt.userAccessList()
                                .filter((item) => item.Type.toLowerCase() === "finance" && item.ParentId == fcAccess.Id);
                                filterAccess.forEach((item) => {
                                    this.fundClusterAccessList.push(
                                    Number(item.Access.split("-")[0])
                                );
                            });
                            this.fcOptions = res.data.filter((item) => this.fundClusterAccessList.includes(item.id));
                        }
                    }

                    this.fundClusters = this.fcOptions.map((obj) => ({
                        value: obj.id,
                        text: obj.cluster,
                    }));
                    this.fundClusters.unshift({
                        value: null,
                        disabled: true,
                        text: "Select Fund cluster...",
                    });
                    this.clusterOptionforTransfer = this.fundClusters;
                })
                .catch(() => {
                    this.alert = {
                        type: "danger",
                        message:
                        "Something went wrong! Cannot fetch fund clusters. Please contact your administrator.",
                    };
            });
        },
        async changeData(cycle, campusId) {
            this.loading = true;
            this.selectedTab = 'pending';
            await this.getFundSources(campusId);
            await this.getDraftEntries(cycle, campusId)
            this.loading = false;
        },
        async getStatus(status) {
            this.selectedTab = status;
            this.loading = true;
            this.journalEntries = [];
            if(status === 'pending'){
                await this.getDraftEntries(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
            } else if(status === 'posted'){
                await this.getPostedEntries(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
            }
            this.loading = false;
        },
        async getDraftEntries(cycle, campusId) {
            await this.$store.dispatch("journalentry/getDraftJournalEntries", { cycle, campusId })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.opened = false;
                        item.detailShow = false;
                        item.filterKey = '';
                        item.showPopover = false;
                        item.journalEntryDetails.map(d => {
                            d.isEdit = false;
                            d.accountSearch = '';
                            d.searched = false;
                            d.failedSearch = false;
                        });
                    })
                    this.journalEntries = res.data;
                })
                .catch((err) => {
                    this.showToast("Error fetching Journals", "error");
                });
        },
        async getPostedEntries(cycle, campusId) {
            await this.$store.dispatch("journalentry/getPostedJournalEntries", { campusId, dateFrom: this.getDate(this.selectedRange[0]), dateTo: this.getDate(this.selectedRange[1]) })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.opened = false;
                        item.detailShow = false;
                        item.filterKey = '';
                        item.showPopover = false;
                        item.journalEntryDetails.map(d => {
                            d.isEdit = false;
                            d.accountSearch = '';
                            d.searched = false;
                            d.failedSearch = false;
                        });
                    })
                    this.journalEntries = res.data;
                })
                .catch((err) => {
                    this.showToast("Error fetching Journals", "error");
                });
        },
        async getJournalTypes(){
            await this.$store
                .dispatch("journaltypes/GetJournalTypes")
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.journals = res.data;
                    this.selectedJournal = this.journals[0] || {};
                })
                .catch((err) => {
                    this.showToast("Something went wrong", "error");
                })
        },
        async getFundSources(id){
            await this.$store
                .dispatch("fundsource/GetActiveFundSourcesByCampusId", id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.fundSources = res.data
                })
                .catch((err) => {
                    this.showToast("Failed to fetch fund sources. Please contact administrator", "error");
                });
        },
        async fetchAccounts(){
            await this.$store
                .dispatch("accounts/getAllAccounts")
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.accounts = res.data;
                })
            .catch((error) => {
                this.showToast("Cannot fetch accounts. Please contact your administrator", "error");
            });
        },
        getJournalEntries(journalId) {
            return this.journalEntries.filter((item) => {
                return item.journalTypeId == journalId;
            });
        },
        addJournal(journal) {
            this.modalTitle = `Add Journal Entry (${journal.journalTypeName})`;
            this.$bvModal.show("jev-modal");
            this.$refs.journalModal.resetForm(journal.id);
        },
        async submitJournal(modalData){
            console.log(modalData);
            if(modalData.id > 0){
                await this.$store
                    .dispatch("journalentry/updateJournalEntry", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        const index = this.journalEntries.findIndex(item => item.id === modalData.id);
                        if(index !== -1){
                            this.journalEntries.splice(index, 1, modalData);
                        }
                        this.showToast("Journal Entry updated successfully", "success");
                        this.$bvModal.hide("jev-modal");
                    })
                    .catch((error) => {
                        this.showToast("", "error");
                    });
            }else{
                await this.$store
                    .dispatch("jev/addJournal", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.journalEntries.push(res.data);
                        this.showToast("Journal Entry added successfully", "success");
                        this.$bvModal.hide("jev-modal");
                    })
                    .catch((error) => {
                        this.showToast("", "error");
                    });
            }
        },
        editJournal(item){
            let data = JSON.parse(JSON.stringify(item));
            data.journalDateTime = new Date(data.journalDateTime);
            this.modalTitle = `Edit Journal Entry (${item.journalType})`;
            this.$bvModal.show("jev-modal");
            this.$refs.journalModal.updateData(data);
        },
        deleteJournal(item) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("journalentry/deleteJournalEntry", item.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            const index = this.journalEntries.findIndex(i => i.id === item.id);
                            if(index !== -1){
                                this.journalEntries.splice(index, 1);
                            }
                            this.showToast("Journal Entry deleted successfully", "success");
                        })
                        .catch((error) => {
                            this.showToast("Failed to delete Journal Entry", "error");
                        });
                }
            });
        },
        printJournal(){},
        printJournals(params){
            let journalType = this.selectedJournal.journalTypeName.replace(/ /g, '').toLowerCase();
            let apiUrl = "";
            let routeVariables = [this.$store.state.data.selectedCampus.id, params.fundCluster];
            if(journalType.includes('debit') || journalType.includes('check') || journalType.includes('cashdisbursement')){
                apiUrl = "/api/Report/Finance/Journal/DV";
                routeVariables = [this.$store.state.data.selectedCampus.id, params.fundCluster, this.selectedJournal.id];
            } else if(journalType.includes('receipts')){
                apiUrl = "/api/Report/Finance/Journal/CRJ";
            }else if(journalType.includes('general')){
                apiUrl = "/api/Report/Finance/Journal/GJ";
            } else {
                return this.showToast("Printing is only available for ADA, Cash Receipts, Cash Disbursements, and Check Disbursements journals.", "error");
            }
            this.$refs.printOpt.putOptions({
                apiUrl: apiUrl,
                routeVariables: routeVariables,
                body: {
                    dateFrom: this.getDate(params.date[0]),
                    dateTo: this.getDate(params.date[1]),
                },
            });
            this.$bvModal.show("print-options-modal");
        },
        printReport(params){
            if(params.selectedOption){
                switch(params.selectedOption){
                    case 'cf':
                        this.printCashFlow(params);
                        break;
                    case 'tb':
                        this.printTrialBalance(params);
                        break;
                    case 'gj':
                        this.printGeneralJournal(params);
                        break;
                    case 'gl':
                        this.printGeneralLedger(params);
                        break;
                    case 'is':
                        this.printIncomeStatement(params);
                        break;
                    case 'dis':
                        this.printDetailedIncomeStatement(params);
                        break;
                    case 'bs':
                        this.printBalanceSheet(params);
                        break;
                    case 'dbs':
                        this.printDetailedBalanceSheet(params);
                        break;
                    case 'coh':
                        this.printCashOnHand(params);
                        break;
                    case 'disbursementreport':
                        this.printDisbursementReport(params);
                        break;
                    case 'checksissued':
                        this.printChecksIssued(params);
                        break;
                    case 'adaissued':
                        this.printADAIssued(params);
                        break;
                    default:
                        this.showToast("Invalid report option selected.", "error");
                }
            } else {
                this.showToast("Please select a report option.", "error");
            }
        },
        printCashFlow(params) {
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/CashFlow",
                routeVariables: [this.$store.state.data.selectedCampus.id],
                body: {
                    // cycle: this.$store.state.data.cycle,
                    fundClusterId: params.fundCluster,
                    date: this.getDate(params.date),
                    // month: params.month,
                },
            });
            this.$bvModal.show("print-options-modal");
        },
        printTrialBalance(params) {
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/Trial/Balance",
                routeVariables: [this.$store.state.data.selectedCampus.id],
                body: {
                    cycle: this.$store.state.data.cycle,
                    fundClusterId: params.fundCluster,
                    // date: this.getDate(params.date),
                    month: params.month,
                },
            });
            this.$bvModal.show("print-options-modal");
        },
        printGeneralJournal(params) {
            this.monthModal = false;
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/Journal/General",
                routeVariables: [
                    this.$store.state.data.selectedCampus.id,
                    this.$store.state.data.cycle,
                    params.month,
                    params.fundCluster,
                ],
            });
            this.$bvModal.show("print-options-modal");
        },
        printGeneralLedger(params) {
            this.monthModal = false;
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/General/Ledger",
                routeVariables: [
                    this.$store.state.data.selectedCampus.id,
                    this.$store.state.data.cycle,
                    params.month,
                    params.fundCluster,
                ],
            });
            this.$bvModal.show("print-options-modal");
        },
        printIncomeStatement(params) {
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/IncomeStatement",
                routeVariables: [this.$store.state.data.selectedCampus.id],
                body: {
                    // cycle: this.$store.state.data.cycle,
                    fundClusterId: params.fundCluster,
                    date: this.getDate(params.date),
                    // month: params.month,
                },
            });
            this.$bvModal.show("print-options-modal");
        },
        printDetailedIncomeStatement(params) {
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/IncomeStatement/Detailed",
                routeVariables: [this.$store.state.data.selectedCampus.id],
                body: {
                    // cycle: this.$store.state.data.cycle,
                    fundClusterId: params.fundCluster,
                    date: this.getDate(params.date),
                    // month: params.month,
                },
            });
            this.$bvModal.show("print-options-modal");
        },
        printBalanceSheet(params) {
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/BalanceSheet",
                routeVariables: [this.$store.state.data.selectedCampus.id],
                body: {
                    cycle: this.$store.state.data.cycle,
                    fundClusterId: params.fundCluster,
                    // date: this.getDate(params.date),
                    month: params.month,
                },
            });
            this.$bvModal.show("print-options-modal");
        },
        printDetailedBalanceSheet(params) {
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/BalanceSheet/Detailed",
                routeVariables: [this.$store.state.data.selectedCampus.id],
                body: {
                    cycle: this.$store.state.data.cycle,
                    fundClusterId: params.fundCluster,
                    // date: this.getDate(params.date),
                    month: params.month,
                },
            });
            this.$bvModal.show("print-options-modal");
        },
        printCashOnHand(params) {
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/CashOnHand",
                routeVariables: [this.$store.state.data.selectedCampus.id],
                body: {
                    // cycle: this.$store.state.data.cycle,
                    fundClusterId: params.fundCluster,
                    date: this.getDate(params.date),
                    // month: params.month,
                },
            });
            this.$bvModal.show("print-options-modal");
        },
        printCashDisbursement() {
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/Journal/Cash/Disbursement",
                routeVariables: [this.selectedCampus],
                body: {
                cycle: this.cycle,
                fundClusterId: this.selectedFundCluster,
                month: this.selectedMonth,
                },
            });
            this.$bvModal.show("print-options-modal");
            this.selectedMonth = null;
            this.selectedFundCluster = null;
            this.selectedPrint = null;
            this.monthModal = false;
        },
        printDisbursementReport(params) {
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/Disbursement/Report",
                routeVariables: [this.$store.state.data.selectedCampus.id],
                body: {
                    dateFrom: params.from,
                    dateTo: params.to,
                },
            });
            this.$bvModal.show("print-options-modal");
        },
        printChecksIssued(params) {
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/Checks/Issued",
                routeVariables: [this.$store.state.data.selectedCampus.id, params.fundCluster],
                body: {
                    dateFrom: params.from,
                    dateTo: params.to,
                },
            });
            this.$bvModal.show("print-options-modal");
        },
        printADAIssued(params) {
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/ADA/Issued",
                routeVariables: [this.$store.state.data.selectedCampus.id, params.fundCluster],
                body: {
                    dateFrom: params.from,
                    dateTo: params.to,
                },
            });
            this.$bvModal.show("print-options-modal");
        },
        getAttachments(data){
            this.$refs.finAttach.setUploadOpt({
                type: "Journal",
                placement: "left",
                folder: "Finance",
            });
            this.$refs.finAttach.getAttachments(data.att, data.id);
            this.$bvModal.show("finance-attachment-modal");
        },
        postJournal(item){
             Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this after posting!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28c76f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, post it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("journalentry/postJournalEntry", item.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            const index = this.journalEntries.findIndex(i => i.id === item.id);
                            if(index !== -1){
                                this.journalEntries.splice(index, 1);
                            }
                            this.showToast("Journal Entry posted successfully", "success");
                        })
                        .catch((error) => {
                            this.showToast("Failed to post Journal Entry", "error");
                        });
                }
            });
        },
    },
};
</script>
<template>
    <Layout 
        @changeCycle="changeData($event, $store.state.data.selectedCampus.id)"
        @changeCampus="changeData($store.state.data.cycle, $event.id)"
    >
        <PageHeader :title="title" :items="items" />
        <template v-if="loading">
            <div class="d-flex justify-content-end">
                <div class="mb-2 d-flex gap-1">
                    <b-skeleton width="150px" height="35px"></b-skeleton>
                    <b-skeleton width="150px" height="35px"></b-skeleton>
                </div>
            </div>
            <div class="d-flex">
                <div style="width: 300px;">
                    <div class="mb-2"><b-skeleton width="100%" height="24px"></b-skeleton></div>
                    <div class="mb-2"><b-skeleton width="100%" height="24px"></b-skeleton></div>
                    <div class="mb-2"><b-skeleton width="100%" height="24px"></b-skeleton></div>
                    <div class="mb-2"><b-skeleton width="100%" height="24px"></b-skeleton></div>
                    <div><b-skeleton width="100%" height="20px"></b-skeleton></div>
                </div>
                <div class="ms-3" style="width:calc(100% - 300px)">
                    <div class="d-flex justify-content-between mb-2">
                        <div>
                            <b-skeleton width="250px" height="30px"></b-skeleton>
                        </div>
                    </div>
                    <div class="mb-2">
                        <b-skeleton width="100%" height="40px"></b-skeleton>
                    </div>
                    <div class="mb-2">
                        <b-skeleton width="100%" height="40px"></b-skeleton>
                    </div>
                    <div class="mb-2">
                        <b-skeleton width="100%" height="40px"></b-skeleton>
                    </div>
                    <div class="mb-2">
                        <b-skeleton width="100%" height="40px"></b-skeleton>
                    </div>
                    <div>
                        <b-skeleton width="100%" height="40px"></b-skeleton>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="d-flex justify-content-between pb-2 border-bottom">
                <div class="d-flex gap-1">
                    <b-form-input
                        v-model="filter"
                        type="text"
                        placeholder="Search Journal Entry..."
                        style="width:280px;"
                    ></b-form-input>
                    <b-form-select
                        class="form-select"
                        v-model="perPage"
                        style="width:70px"
                        :options="pageOptions"
                    ></b-form-select>
                    <div class="border rounded py-2 px-5 d-flex align-items-center justify-content-center cursor-pointer"
                        :class="{'bg-purple text-white': selectedTab === 'pending' }"
                        @click="getStatus('pending')"
                    >
                        <p class="mb-0 font-size-14">Pending</p>
                    </div>
                    <div class="border rounded py-2 px-5 d-flex align-items-center justify-content-center cursor-pointer"
                        :class="{'bg-success text-white': selectedTab === 'posted' }"
                        @click="getStatus('posted')"
                    >
                        <p class="mb-0 font-size-14">Posted</p>
                    </div>
                    <date-picker
                        v-if="selectedTab === 'posted'"
                        v-model="selectedRange"
                        :first-day-of-week="1"
                        lang="en"
                        range
                        placeholder="Enter Date..."
                    >
                    </date-picker>
                </div>
                <div class="d-flex gap-1">
                    <FinanceOverviewReports 
                        ref="financeReport"
                        :fundClusters="fundClusters"
                        :months="months"
                        @generate-report="printReport"
                    />
                    <JournalReports 
                        ref="journalReport"
                        :fundClusters="fundClusters"
                        :months="months"
                        @generate-report="printJournals"
                    />
                </div>
            </div>
            <div class="mt-2">
                <b-tabs
                    v-model="tabModel"
                    pills
                    vertical
                    nav-class="p-0"
                    nav-wrapper-class="col-sm-2 border-end"
                    content-class="pt-0 px-2 text-muted"
                >
                    <b-tab v-for="journal in journals" :key="journal.id" @click="selectedJournal = journal">
                        <template v-slot:title>
                            {{ journal.journalTypeName }}
                        </template>
                        <JournalEntries 
                            :entries="getJournalEntries(journal.id)"
                            :type="journal.journalTypeName"
                            :statusType="selectedTab"
                            :filter="filter"
                            @add-entry="addJournal(journal)"
                            @edit-entry="editJournal"
                            @delete-entry="deleteJournal"
                            @print-journal="printJournal"
                            @post-entry="postJournal"
                            @attachment="getAttachments"
                        />
                    </b-tab>
                </b-tabs>
            </div>
        </template>
        <JournalModal 
            ref="journalModal" 
            :modalTitle="modalTitle"
            :fundSources="fundSources"
            :accounts="accounts"
            @submit="submitJournal"
        />
        <print-options ref="printOpt"></print-options>
        <FinanceAttachments 
            ref="finAttach"
            :wActions="true"
        />
    </Layout>
</template>